import axios from "axios";
import {API_SERVER_URL, API_SERVER_PORT, API_SERVER_TTSSERVICE} from './../../actions/actionTypes';

// const baseURL= `${API_SERVER_URL}:${API_SERVER_PORT}/${API_SERVER_TTSSERVICE}/`;
const baseURL= `${API_SERVER_URL}:${API_SERVER_PORT}/${API_SERVER_TTSSERVICE}/`;
// const baseURL= `http://18.222.71.135:3030/TTSService/`;
console.log(process.env.REACT_APP_API_SERVER_URL)
export const instance = axios.create({

    baseURL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",  'Cache-Control': 'no-cache' 
    }
});